export default __webpack_public_path__ + "4e31269290514695a2dc34b9f3ac5816.png";